import * as wizeMobileApi from '@wize-mobile-api';
import {
  ApiOrderCreationStatusEnum,
  InstructionTypeValueEnum,
  InvestmentOrder,
  LimitTypeValueEnum,
  OrderSideEnum,
  OrderStatusEnum
} from '@qvs/core';

export class InvestmentOrderMapper {
  public static fromWizeOrder = (wizeOrder: wizeMobileApi.StockMarketOrderMobile): InvestmentOrder | undefined => {
    if (!wizeOrder) {
      return undefined;
    }
    const {
      gross,
      grossCurrencyId,
      net,
      netCurrencyId,
      instructionTypeValue,
      limitTypeValue,
      orderSide,
      orderStatus,
      apiOrderCreationStatus,
      apiOrderStatus,
      ...additionalProps
    } = wizeOrder;
    return {
      grossAmount: { value: gross, currency: grossCurrencyId },
      netAmount: { value: net, currency: netCurrencyId },
      instructionTypeValue: instructionTypeValue as InstructionTypeValueEnum,
      limitTypeValue: limitTypeValue as LimitTypeValueEnum,
      orderSide: orderSide as OrderSideEnum,
      orderStatus: InvestmentOrderMapper.fromWizeApiOrderStatus(apiOrderStatus),
      apiOrderCreationStatus: apiOrderCreationStatus as ApiOrderCreationStatusEnum,
      ...additionalProps
    };
  };

  public static fromWizeOrders = (wizeOrders: wizeMobileApi.StockMarketOrderMobile[]): InvestmentOrder[] =>
    wizeOrders.map((wizeOrder) => InvestmentOrderMapper.fromWizeOrder(wizeOrder));

  private static fromWizeApiOrderStatus(
    wizeOrderStatus: wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum
  ): OrderStatusEnum {
    let status = OrderStatusEnum.PENDING;
    switch (wizeOrderStatus) {
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.EXECUTED:
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.APPROVED:
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.ACCOUNTED:
        status = OrderStatusEnum.EXECUTED;
        break;
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.FAILED:
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.DECLINED:
        status = OrderStatusEnum.DELETED;
        break;
      case wizeMobileApi.StockMarketOrderMobile.ApiOrderStatusEnum.EXPIRED:
        status = OrderStatusEnum.EXPIRED;
        break;
    }
    return status;
  }
}
